import { render } from "./custom-fields-modal.vue?vue&type=template&id=ffab418c"
import script from "./custom-fields-modal.vue?vue&type=script&lang=js"
export * from "./custom-fields-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__